import { Container, Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

export default function Datenschutz() {
  return (
    <Container sx={{ py: 8, color: 'text.primary', maxWidth: '800px' }}>
      <Helmet>
        <title>Datenschutz | EDEB Estrichbau</title>
      </Helmet>
      
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 4 }}>
        <Typography variant="h3" color="primary">
          Datenschutzerklärung
        </Typography>
        <Box component="img" src="/logo.png" alt="EDEB-Estrichbau" sx={{ height: 80, backgroundColor: "white", padding: "4px", borderRadius: "8px", display: { xs: 'none', sm: 'block' } }} />
      </Box>
      
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom color="primary">
          Datenschutz auf einen Blick
        </Typography>
        <Typography paragraph>
          Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten Ihre Daten
          ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG).
        </Typography>

        <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4 }}>
          Datenerfassung auf unserer Website
        </Typography>
        <Typography paragraph>
          Verantwortlich für die Datenverarbeitung ist:<br />
          EDEB-Estrichbau<br />
          Inhaber: Erkan Demirci<br />
          65760 Eschborn<br />
          Telefon: 0162 4196199<br />
          E-Mail: edeb-estrichbau@web.de
        </Typography>

        <Typography paragraph>
          <strong>Wie erfassen wir Ihre Daten?</strong> Daten werden z. B. erhoben, wenn Sie uns eine
          Nachricht senden oder unser Kontaktformular nutzen. Außerdem werden technische
          Daten automatisch erfasst (z. B. Browsertyp, Uhrzeit).
        </Typography>

        <Typography paragraph>
          <strong>Wofür nutzen wir Ihre Daten?</strong> Wir nutzen Ihre Daten zur Bearbeitung Ihrer Anfrage
          und zur Bereitstellung der Website.
        </Typography>

        <Typography paragraph>
          <strong>Welche Rechte haben Sie?</strong> Sie haben jederzeit das Recht auf Auskunft,
          Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit,
          Widerruf und Widerspruch.
        </Typography>

        <Box sx={{ height: 1, bgcolor: "divider", my: 4 }} />

        <Typography variant="h6" gutterBottom color="primary">
          Kontaktformular
        </Typography>
        <Typography paragraph>
          Wenn Sie uns über das Kontaktformular kontaktieren, werden Ihre Daten zur
          Bearbeitung gespeichert. Die Daten werden nicht ohne Ihre Einwilligung
          weitergegeben.
        </Typography>

        <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4 }}>
          Google Maps
        </Typography>
        <Typography paragraph>
          Diese Seite nutzt über eine API den Kartendienst Google Maps. Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Wir haben eine "2-Klick-Lösung" implementiert, sodass Ihre Daten erst nach Ihrer ausdrücklichen Zustimmung (Klick auf "Karte laden") an Google übertragen werden.
        </Typography>

        <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 4 }}>
          Server-Logfiles
        </Typography>
        <Typography paragraph>
          Der Provider speichert automatisch Logfiles (z. B. Browsertyp, Betriebssystem,
          Referrer, Uhrzeit). Diese Daten sind nicht bestimmten Personen zuordenbar.
        </Typography>
      </Box>
    </Container>
  );
}
